export default "__VITE_ASSET__BZ6_h3H2__"